import * as has from "lodash/has"

interface RedMailFileUploadProps {
    handleSelectedFile: (e: any) => void
    selectedFiles: any
    hashes: string[]
    invalidFilesName: string[]
    showFileStatusProgress: (fileKey: any) => string
    handleRemoveFile?: (fileKey: string) => void
}

export class RedMailFileUploadYnet extends React.Component<RedMailFileUploadProps, {}> {

    render() {
        const { handleSelectedFile, selectedFiles, invalidFilesName, hashes, showFileStatusProgress, handleRemoveFile } = this.props;
    
        return (
            <div className="RedMailFilesUpload">
                <div style={{ display: Object.keys(selectedFiles).length > 0 && "none" }} className="FilesUploadButtonWrapper">
                    <input type="file" id="inputFile"
                        onChange={handleSelectedFile}
                        multiple
                    />
                    <button className="FilesUploadButton">
                        הוספת קובץ
                        <div className="uploadIcon"></div>
                    </button>
                </div>
                
                <div className="addFileWrapper">
                    <div className="addFileInputWrapper">
                        {Object.keys(selectedFiles).length > 0 && <div className="fileWrapper" style={{ width: '100%' }}>
                            {Object.keys(selectedFiles).map((fileKey, i) => {
                                const fileUploadProgress = showFileStatusProgress(fileKey);
                                return <div className="fileName" key={fileKey} title={selectedFiles[fileKey].fileName}>
                                    <div className="fileNameIcon">
                                        <button className="fileDelete" alt="מחיקת קובץ" style={{pointerEvents: fileUploadProgress ? 'none' : 'auto'}} onClick={() => handleRemoveFile(fileKey)}></button>   
                                            <div className="fileText">
                                                    {selectedFiles[fileKey].fileName.split('.').pop()}
                                            </div>
                                        </div>
                                    <div className="FileNameIconsWrapper"> 
                                         {fileUploadProgress && <div className="FileNameLoadingIcon"></div>}                                      {has(selectedFiles[fileKey], "progress") && <div className="FileNameLoadingIcon"></div>}
                                    </div>
                                    <input type="text" dir="rtl" />
                                </div>
                            })}
                        </div>}
                        {Object.keys(selectedFiles).length > 0 && Object.keys(selectedFiles).length < 5 &&
                            <div className="FilesUploadButtonWrapper" onClick={() => document.getElementById("inputFile").click()}>
                            <div className="FilesUploadButton">הוספת קובץ
                            <div className="uploadIcon"></div>
                            </div>
                            </div>
                            
                        }
                       
                       
                        {!!invalidFilesName.length && <div className="files-names-error-row">
                            {invalidFilesName.map(file => <span key={file}> הקובץ {`${file}`}  כבד מדיי – העלה קובץ עד 200 מגה בלבד  </span>)}
                        </div>}
                    </div>
                </div>
            </div>
        )
    }
}
